import raw from '../../../property-location.json';
import { buildNwsMapClickUrl } from '../utils/nwsMapClickUrl';

export type PropertyLocationConfig = {
  version: number;
  displayName: string;
  shortName: string;
  description?: string;
  latitude: number;
  longitude: number;
  timezone: string;
  nws: {
    zone: string;
    countyZone: string;
    office: string;
    state: string;
    mapClickCity: string;
  };
  wundergroundStation: string;
  texMesonet: {
    primaryStationId: string;
    primaryStationName: string;
    backupStationId: string;
  };
  news: {
    localTerms: string[];
    eventsTerms: string[];
  };
};

export const propertyLocation = raw as PropertyLocationConfig;
